/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS AUTOMATICALLY GENERATED FROM API ROUTES      ##
 * ---------------------------------------------------------------
 */

export const THREADS_PATHS = {
  APP_CONTROLLER_HEALTH_CHECK: '/healthcheck' as const,
  THREAD_CONTROLLER_GET_THREADS: '/threads' as const,
  THREAD_CONTROLLER_UPDATE_THREADS: '/threads' as const,
  THREADS_THREAD_CONTROLLER_GET_TOKEN: '/threads/token' as const,
  THREADS_THREAD_CONTROLLER_CREATE_CONNECTION: '/threads/connection' as const,
  THREADS_THREAD_CONTROLLER_UPDATE_CONNECTION: '/threads/connection/{connection_id}' as const,
  THREADS_THREAD_CONTROLLER_DELETE_CONNECTION: '/threads/connection/{connection_id}' as const,
  THREADS_THREAD_CONTROLLER_GET_UNREAD_CHANNELS: '/threads/unread' as const,
  THREAD_CONTROLLER_GET_THREADS_LAST_ACTIVITY: '/threads/last-activity' as const,
  THREAD_CONTROLLER_GET_THREADS_AGGREGATE: '/threads/aggregate' as const,
  THREADS_THREAD_CONTROLLER_GET_THREAD: '/threads/{thread_id}' as const,
  THREADS_THREAD_CONTROLLER_CREATE_THREAD_CHANNELS: '/threads/{thread_id}' as const,
  THREADS_THREAD_CONTROLLER_UPDATE_THREAD_MEMBERS: '/threads/{thread_id}/members' as const,
  WEBHOOK_CONTROLLER_HANDLE_WEBHOOK: '/webhook/{source}' as const,
} as const;

export const buildAppControllerHealthCheckPath = () => '/healthcheck';

export const buildThreadControllerGetThreadsPath = () => '/threads';

export const buildThreadControllerUpdateThreadsPath = () => '/threads';

export const buildThreadsThreadControllerGetTokenPath = () => '/threads/token';

export const buildThreadsThreadControllerCreateConnectionPath = () => '/threads/connection';

export const buildThreadsThreadControllerUpdateConnectionPath = (params: { connection_id: string }) => `/threads/connection/${params.connection_id}`;

export const buildThreadsThreadControllerDeleteConnectionPath = (params: { connection_id: string }) => `/threads/connection/${params.connection_id}`;

export const buildThreadsThreadControllerGetUnreadChannelsPath = () => '/threads/unread';

export const buildThreadControllerGetThreadsLastActivityPath = () => '/threads/last-activity';

export const buildThreadControllerGetThreadsAggregatePath = () => '/threads/aggregate';

export const buildThreadsThreadControllerGetThreadPath = (params: { thread_id: string }) => `/threads/${params.thread_id}`;

export const buildThreadsThreadControllerCreateThreadChannelsPath = (params: { thread_id: string }) => `/threads/${params.thread_id}`;

export const buildThreadsThreadControllerUpdateThreadMembersPath = (params: { thread_id: string }) => `/threads/${params.thread_id}/members`;

export const buildWebhookControllerHandleWebhookPath = (params: { source: string }) => `/webhook/${params.source}`;
